module.exports = __webpack_public_path__ + "img/repeat.f9423414.svg";